import { type Meta } from '../types/docs';

const META: Meta = {
  description:
    'Called when a user experiences a banner or popover after hitting a credit consumption milestone and dismisses the message',
  name: 'credit_warning_popover_dismissed',
  params: [
    {
      description: 'The type of warning UI that was dismissed',
      name: 'type',
      required: true,
      type: 'enum',
      values: ['popover', 'banner'],
    },
    {
      description: 'Percentage of credits used',
      name: 'pct_used',
      required: true,
      type: 'number',
    },
    {
      description: 'Number of days since the billing cycle started',
      name: 'days_since_cycle_start',
      required: true,
      type: 'number',
    },
  ],
};

export default META;
